export enum Status {
  INACTIVE = '0',
  ACTIVE = '1',
  DELETED = '-1',
  PENDING = '2',
}
